// Öffnen/Schließen & Toolbar
document.querySelector(".product-info__engraving .open-button").addEventListener("click", () => {
  const box = document.getElementById("EngravingBox");
  box.style.display = "";
});

document.querySelector("#EngravingBox .close-button").addEventListener("click", () => {
  document.getElementById("EngravingBox").style.display = "none";
});

document.querySelector(".button-show-text-input").addEventListener("click", () => {
  document.querySelector(".form-control--text-input").classList.remove("hidden");
  document.querySelector(".font-wrapper").classList.remove("hidden");
  document.querySelector(".engraving-toolbar").classList.add("hidden-important");
  document.querySelector(".button-back-to-start").classList.remove("hidden-important");
  document.querySelector(".engraving-text-input").focus();
});

document.querySelector(".button-show-image-input").addEventListener("click", () => {
  document.querySelector(".image-input-wrapper").classList.remove("hidden");
  document.querySelector(".engraving-toolbar").classList.add("hidden-important");
  document.querySelector(".button-back-to-start").classList.remove("hidden-important");
});

document.querySelector(".button-back-to-start").addEventListener("click", () => {
  document.querySelector(".form-control--text-input").classList.add("hidden");
  document.querySelector(".font-wrapper").classList.add("hidden");
  document.querySelector(".image-input-wrapper").classList.add("hidden");
  document.querySelector(".engraving-toolbar").classList.remove("hidden-important");
  document.querySelector(".button-back-to-start").classList.add("hidden-important");
});


if (!customElements.get("silwy-engraving-single")) {
  class SilwyEngravingSingle extends HTMLElement {
    constructor() {
      super();

      this.engravingButton = document.querySelector(".product-info__engraving .open-button");

      this.engravingCanvas = this.querySelector("#engravingCanvasText");
      this.engravingCtx = this.engravingCanvas.getContext("2d");
      this.engravingCanvasBackground = this.querySelector("#engravingCanvasBackground");
      this.engravingBackgroundCtx = this.engravingCanvasBackground.getContext("2d");

      this.engravingCanvas.width = 250;
      this.engravingCanvas.height = 500;
      this.engravingCanvasBackground.width = 250;
      this.engravingCanvasBackground.height = 500;

      const bgCtx = this.engravingBackgroundCtx;
      const background = new Image();
      background.src = this.dataset.engravingImage;
      background.onload = function () {
        bgCtx.drawImage(background, 0, 0);
      };

      this.allowedCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      // Selektoren
      this.engravingTextField =
        this.querySelector(".engraving-text-input") || this.querySelector("#engravingTextField");
      this.hiddenInputFont = this.querySelector(".hidden-input-font");
      this.hiddenInputIds = this.querySelectorAll(".hidden-input-id");
      this.hiddenInputFonts = this.querySelectorAll(".hidden-input-font");
      this.hiddenInputTexts = this.querySelectorAll(".hidden-input-text");
      this.hiddenEngravingInputs = this.querySelectorAll(".engraving-hidden-inputs");

      // neue Hidden Inputs für Motiv
      this.hiddenInputMotif = this.querySelectorAll(".hidden-input-motif");
      this.hiddenInputMotifName = this.querySelectorAll(".hidden-input-motif-name");

      this.motif = null;

      // Motiv-Buttons (mit name + src)
      this.querySelectorAll(".engraving-motif").forEach((btn) => {
        btn.addEventListener("click", () =>
          this.loadMotif(btn.dataset.src, btn.dataset.name)
        );
      });

      this.qtyButton = document.querySelector(".quantity-selector__input");
      this.minusButton = document.querySelectorAll(".quantity-selector__button")[0];
      this.plusButton = document.querySelectorAll(".quantity-selector__button")[1];
      this.engravingQty = this.querySelector(".hidden-engraving-qty");

      this.fontInputs = this.querySelectorAll("input.font-radio");

      this.maxInputLength =
        this.querySelector("#maxInputLength") || this.querySelector("[data-max-length]");
      this.fontName =
        this.querySelector("#fontName") || this.querySelector("[data-font-name]");
      this.currentInputLength =
        this.querySelector("#currentInputLength") || this.querySelector("[data-current-length]");

      this.engravingSubmitButton = this.querySelector(".submitEngraving");
      this.cancelEngravingButton = this.querySelector(".cancelEngraving");

      this.engravingValidationInfo =
        this.querySelector("#engravingValidationInfo") ||
        this.querySelector("[data-validation-info]");

      this.addEngravingId();

      if (this.qtyButton)
        this.qtyButton.addEventListener("change", this.updateEngravingQty.bind(this));
      if (this.minusButton)
        this.minusButton.addEventListener("click", this.updateEngravingQty.bind(this));
      if (this.plusButton)
        this.plusButton.addEventListener("click", this.updateEngravingQty.bind(this));

      for (const fontInput of this.fontInputs) {
        fontInput.addEventListener("change", this.fontSwitch.bind(this, fontInput));
      }

      if (this.engravingTextField) {
        this.engravingTextField.addEventListener("keyup", this.engravingDraw.bind(this));
        this.engravingTextField.addEventListener("input", this.engravingInputValidation.bind(this));
        this.engravingTextField.addEventListener("keyup", this.writeInputEngraving.bind(this));
      }

      if (this.engravingSubmitButton)
        this.engravingSubmitButton.addEventListener("click", this.submitEngraving.bind(this));

      if (this.cancelEngravingButton)
        this.cancelEngravingButton.addEventListener("click", this.cancelEngraving.bind(this));

      try {
        const anyHidden = this.hiddenEngravingInputs?.[0];
        const targetForm = anyHidden?.form || document.querySelector('form[action*="/cart/add"]');
        const formSubmitBtn = targetForm?.querySelector('[type="submit"], button[name="add"]');
        if (formSubmitBtn && this.engravingSubmitButton) {
          const addText = formSubmitBtn.textContent?.trim();
          if (addText?.length) this.engravingSubmitButton.textContent = addText;
        }
      } catch (e) {}

      this.updateSubmitState();
    }

    safeSetInnerHTML(element, value) {
      if (element && element.innerHTML !== undefined) {
        element.innerHTML = value;
        return true;
      }
      return false;
    }

    // Button aktiv, wenn Text ODER Motiv vorhanden
    updateSubmitState() {
      const btn = this.engravingSubmitButton;
      if (!btn) return;
      const hasText = !!this.engravingTextField?.value?.trim().length;
      const hasMotif = !!(this.motif);
      btn.toggleAttribute("disabled", !(hasText || hasMotif));
    }

    engravingDraw() {
      if (!this.engravingCtx || !this.hiddenInputFont) return;
      const ctx = this.engravingCtx;
      const canvas = this.engravingCanvas;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.motif) {
        this.drawMotif(ctx);
        return;
      }
      if (!this.engravingTextField) return;
      ctx.fillStyle = this.dataset.engravingColor;
      ctx.textAlign = "center";
      ctx.font = `${this.dataset.engravingSize}px '${this.hiddenInputFont.value}'`;
      const x = parseInt(this.dataset.engravingX, 10);
      const y = parseInt(this.dataset.engravingY, 10);
      ctx.fillText(this.engravingTextField.value, x, y);
    }

    addEngravingId() {
      const allowed = this.allowedCharacters;
      const hidden = this.hiddenInputIds;
      const rand = Array.from({ length: 16 }, () => allowed[Math.floor(Math.random() * allowed.length)]).join("");
      for (const input of hidden) if (input) input.value = rand;
    }

    updateEngravingQty() {
      if (this.engravingQty && this.qtyButton) this.engravingQty.value = this.qtyButton.value;
    }

    engravingInputValidation() {
      if (!this.engravingTextField) return;
      if (this.engravingValidationInfo) {
        this.engravingValidationInfo.style.display = "none";
        if (this.engravingTextField.value.match(/[^a-zA-Z0-9!\/()=&+?:;,.\-ßéäöüÄÖÜ\s]/g, "")) {
          this.engravingValidationInfo.style.display = "";
        }
      }
      this.engravingTextField.value = this.engravingTextField.value.replace(
        /[^a-zA-Z0-9!\/()=&+?:;,.\-ßéäöüÄÖÜ\s]/g, ""
      );

      if (this.motif && this.engravingTextField.value.trim().length > 0) {
        this.motif = null;
        for (const m of this.hiddenInputMotif) m.value = "";
        for (const n of this.hiddenInputMotifName) n.value = "";
        this.engravingDraw();
      }

      this.updateSubmitState();
    }

    fontSwitch(el) {
      if (!el || !el.checked) return;
      this.safeSetInnerHTML(this.fontName, el.value);
      if (this.engravingTextField) this.engravingTextField.maxLength = el.dataset.fontLimitation;
      this.safeSetInnerHTML(this.maxInputLength, el.dataset.fontLimitation);
      this.dataset.engravingSize = el.dataset.fontSize;
      for (const hiddenInput of this.hiddenInputFonts) if (hiddenInput) hiddenInput.value = el.value;
      if (this.engravingTextField && this.engravingTextField.value.length > this.engravingTextField.maxLength)
        this.engravingTextField.value = this.engravingTextField.value.slice(0, this.engravingTextField.maxLength);
      this.safeSetInnerHTML(this.currentInputLength, this.engravingTextField?.value?.length?.toString() || "0");
      this.engravingDraw();
      this.addEngravingId();
      this.updateSubmitState();
    }

    writeInputEngraving() {
      if (this.motif && this.engravingTextField.value.trim().length > 0) {
        this.motif = null;
        for (const m of this.hiddenInputMotif) m.value = "";
        for (const n of this.hiddenInputMotifName) n.value = "";
      }
      if (!this.engravingTextField) return;
      this.safeSetInnerHTML(this.currentInputLength, this.engravingTextField.value.length.toString());
      for (const hiddenInput of this.hiddenInputTexts) if (hiddenInput) hiddenInput.value = this.engravingTextField.value;
      this.addEngravingId();
      this.updateSubmitState();
      this.engravingDraw();
    }

    cancelEngraving() {
      this.safeSetInnerHTML(this.currentInputLength, "0");
      for (const h of this.hiddenEngravingInputs) h.setAttribute("disabled", "");
      if (this.engravingTextField) this.engravingTextField.value = "";
      if (this.engravingSubmitButton) this.engravingSubmitButton.setAttribute("disabled", "");
      if (this.engravingButton) this.engravingButton.classList.remove("active");
      const box = document.getElementById("EngravingBox");
      if (box) box.style.display = "none";
      this.motif = null;
      for (const m of this.hiddenInputMotif) m.value = "";
      for (const n of this.hiddenInputMotifName) n.value = "";
      this.engravingDraw();
      const open = document.querySelector(".product-info__engraving .open-button");
      if (open && window.engraving?.open_button) open.innerHTML = window.engraving.open_button;
      this.updateSubmitState();
    }

    submitEngraving() {
      // Alle relevanten Hidden Inputs aktivieren
      const allHidden = this.querySelectorAll(
        ".engraving-hidden-inputs, .hidden-input-motif, .hidden-input-motif-name"
      );
      allHidden.forEach((el) => el.removeAttribute("disabled"));

      const hasText = !!this.engravingTextField?.value?.trim().length;
      const hasMotif = !!this.motif;

      // 🧠 SINGLE-Logik
      if (hasText && !hasMotif) {
        this.querySelectorAll(".hidden-input-motif, .hidden-input-motif-name").forEach((el) =>
          el.setAttribute("disabled", "")
        );
      }

      if (hasMotif && !hasText) {
        this.querySelectorAll(".hidden-input-text, .hidden-input-font").forEach((el) =>
          el.setAttribute("disabled", "")
        );
      }

      if (!hasText && !hasMotif) {
        allHidden.forEach((el) => el.setAttribute("disabled", ""));
      }

      // 🛒 Add-to-cart
      const anyHidden = this.hiddenEngravingInputs?.[0];
      const form = anyHidden?.form || document.querySelector('form[action*="/cart/add"]');

      if (this.engravingButton) this.engravingButton.classList.add("active");
      const box = document.getElementById("EngravingBox");
      if (box) box.style.display = "none";

      if (form) {
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      } else {
        console.warn("[SilwyEngraving] Kein Ziel-Formular gefunden.");
      }

      // ─────────────────────────────────────────────────────────────
      // 🧼 Nach dem Submit: Gravur-Box vollständig zurücksetzen
      // ─────────────────────────────────────────────────────────────
      setTimeout(() => {
        // Texte und Motive löschen
        if (this.engravingTextField) this.engravingTextField.value = "";
        this.motif = null;

        // Hidden Inputs leeren (aber Font auf Standard zurücksetzen)
        const clearSelectors = [
          ".hidden-input-text",
          ".hidden-input-motif",
          ".hidden-input-motif-name",
          
        ];

        clearSelectors.forEach((sel) => {
          this.querySelectorAll(sel).forEach((el) => {
            el.value = "";
            el.setAttribute("disabled", "");
          });
        });

        // Schriftart auf Standard zurücksetzen
        this.querySelectorAll(".hidden-input-font").forEach((el) => {
          el.value = "Caliban Std";
          el.setAttribute("disabled", "");
        });

        // Falls Fontname im UI sichtbar ist → aktualisieren
        if (this.fontName) this.safeSetInnerHTML(this.fontName, "Caliban Std");

        // Canvas leeren
        if (this.engravingCtx && this.engravingCanvas)
          this.engravingCtx.clearRect(0, 0, this.engravingCanvas.width, this.engravingCanvas.height);

        // Alle Gravur-Inputs wieder deaktivieren
        this.querySelectorAll(".engraving-hidden-inputs").forEach((el) =>
          el.setAttribute("disabled", "")
        );

        // Buttons / UI zurücksetzen
        if (this.engravingSubmitButton) this.engravingSubmitButton.setAttribute("disabled", "");
        if (this.engravingButton) this.engravingButton.classList.remove("active");

        document.querySelector(".form-control--text-input")?.classList.add("hidden");
        document.querySelector(".font-wrapper")?.classList.add("hidden");
        document.querySelector(".image-input-wrapper")?.classList.add("hidden");
        document.querySelector(".engraving-toolbar")?.classList.remove("hidden-important");
        document.querySelector(".button-back-to-start")?.classList.add("hidden-important");

        this.updateSubmitState();
        console.log("[SilwyEngraving] GravurBox nach Submit vollständig zurückgesetzt.");
      }, 800);
    }







    // Motiv laden (src + name)
    loadMotif(src, name) {
      if (!src) return;

      // Geräte- / Browsererkennung
      const ua = navigator.userAgent;
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

      const originalSrc = src;
      if (src.startsWith("//")) src = "https:" + src;

      // 🧩 Safari-Bug-Fix:
      // Safari rendert viele SVGs (mit Transparenzen oder CSS fills) im Canvas nicht.
      // Deshalb für Safari einen PNG-Fallback vom Shopify-CDN erzwingen.
      if (isSafari && src.includes(".svg") && !src.includes("format=png")) {
        if (src.includes("?")) src += "&format=png";
        else src += "?format=png";
        console.log("[Engraving] Safari erkannt → PNG-Fallback aktiviert:", src);
      }

      // 🧾 Laden mit fetch() → Blob → Image
      fetch(src)
        .then((res) => {
          if (!res.ok) throw new Error("Motiv konnte nicht geladen werden");
          return res.blob();
        })
        .then((blob) => {
          const objectURL = URL.createObjectURL(blob);
          const img = new Image();

          img.onload = () => {
            console.log("[Engraving] Motiv geladen:", { name, src, width: img.naturalWidth, height: img.naturalHeight });

            this.motif = { img, scale: 1, rotation: 0, src: originalSrc, name };

            // Textfelder leeren, aber Schriftart behalten
            if (this.engravingTextField) this.engravingTextField.value = "";
            for (const t of this.hiddenInputTexts) t.value = "";

            // Hidden Inputs (für Warenkorb)
            for (const m of this.hiddenInputMotif) m.value = originalSrc;
            for (const n of this.hiddenInputMotifName) n.value = name || "";

            this.updateSubmitState();
            this.engravingDraw();

            URL.revokeObjectURL(objectURL);
          };

          img.onerror = (err) => console.error("[Engraving] Image.onload Fehler:", err);
          img.src = objectURL;
        })
        .catch((err) => console.error("[Engraving] Fetch-Fehler beim Laden des Motivs:", err));
    }




    drawMotif(ctx) {
      if (!this.motif) return;
      const { img, scale, rotation } = this.motif;
      // const w = img.width * scale;
      // const h = img.height * scale;
      const w = 80;
      const h = (w / img.width) * img.height;

      const x = parseInt(this.dataset.engravingX, 10) || 125;
      const y = parseInt(this.dataset.engravingY, 10) || 250;
      console.log("[Engraving] drawMotif:", { x, y, w, h, rotation });
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.drawImage(img, -w / 2, -h, w, h);
      ctx.restore();
    }
  }

  customElements.define("silwy-engraving-single", SilwyEngravingSingle);

  // ──────────────────────────────────────────────────────────────────────────
  // Multi: pro Item eigene Texte/Fonts/Motive + Button-State (Text ODER Bild je Item)
  class SilwyEngravingMulti extends SilwyEngravingSingle {
    constructor() {
      super();

      // Pro-Item Motiv-Store: { "1": {img,scale,rotation,src,name}, "2": {...} }
      this.motifs = {};

      this.itemInputs = this.querySelectorAll("input.engraving-item");
      this.engravingQty = this.querySelectorAll(".hidden-engraving-qty");

      for (const itemInput of this.itemInputs) {
        itemInput.addEventListener("change", this.itemSwitch.bind(this, itemInput));
      }
    }

    engravingDraw() {
      const ctx = this.engravingCtx;
      const canvas = this.engravingCanvas;
      if (!ctx || !canvas) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Motiv aktiv?
      if (this.motif) {
        this.drawMotif(ctx);
        return;
      }

      if (!this.engravingTextField) return;

      const checkedItem = this.querySelector("input.engraving-item:checked");
      if (!checkedItem) return;

      const fontElement = this.querySelector(".hidden-input-font.hidden-item-" + checkedItem.value);
      if (!fontElement) return;

      ctx.fillStyle = this.dataset.engravingColor;
      ctx.font = this.dataset.engravingSize + "px '" + fontElement.value + "'";
      ctx.textAlign = "center";
      ctx.fillText(
        this.engravingTextField.value,
        parseInt(this.dataset.engravingX, 10),
        parseInt(this.dataset.engravingY, 10)
      );
    }

    updateEngravingQty() {
      if (!this.qtyButton) return;
      for (const qty of this.engravingQty) {
        if (qty) qty.value = this.qtyButton.value;
      }
    }

    // Fontwechsel pro Item
    fontSwitch(el) {
      if (!el || !el.checked) return;

      this.safeSetInnerHTML(this.fontName, el.value);

      if (this.engravingTextField)
        this.engravingTextField.maxLength = el.dataset.fontLimitation;

      this.safeSetInnerHTML(this.maxInputLength, el.dataset.fontLimitation);
      this.dataset.engravingSize = el.dataset.fontSize;

      const checkedItem = this.querySelector("input.engraving-item:checked");
      if (checkedItem) {
        for (const hideFont of this.querySelectorAll(
          ".hidden-input-font.hidden-item-" + checkedItem.value
        )) {
          if (hideFont) hideFont.value = el.value;
        }
      }

      if (
        this.engravingTextField &&
        this.engravingTextField.value.length > this.engravingTextField.maxLength
      ) {
        this.engravingTextField.value = this.engravingTextField.value.slice(
          0,
          this.engravingTextField.maxLength
        );
      }

      if (this.engravingTextField) {
        this.safeSetInnerHTML(
          this.currentInputLength,
          this.engravingTextField.value.length.toString()
        );
      }

      this.engravingDraw();
      this.addEngravingId();
      this.updateSubmitState();
    }

    // Item wechseln: Text/Font übernehmen + Motiv pro Item wiederherstellen
    itemSwitch(el) {
      if (!el || !el.checked) return;

      // Text spiegeln
      const textElement = this.querySelector(".hidden-input-text.hidden-item-" + el.value);
      if (this.engravingTextField) {
        this.engravingTextField.value = textElement?.value ?? "";
        this.safeSetInnerHTML(
          this.currentInputLength,
          this.engravingTextField.value.length.toString()
        );
      }

      // Fonts setzen
      for (const fontInput of this.fontInputs) {
        if (fontInput) fontInput.checked = false;
      }

      const fontElement = this.querySelector(".hidden-input-font.hidden-item-" + el.value);
      if (fontElement && fontElement.value.length === 0) {
        const defaultFont = this.querySelector(".hidden-input-font.hidden-item-1");
        if (defaultFont) {
          for (const hiddenFont of this.querySelectorAll(
            ".hidden-input-font.hidden-item-" + el.value
          )) {
            if (hiddenFont) hiddenFont.value = defaultFont.value;
          }
        }
      }

      if (fontElement) {
        const fontRadio = this.querySelector("#font" + fontElement.value.replace(" ", ""));
        if (fontRadio) fontRadio.checked = true;
      }

      for (const fontInput of this.fontInputs) {
        if (fontInput && fontInput.checked === true) {
          if (this.engravingTextField)
            this.engravingTextField.maxLength = fontInput.dataset.fontLimitation;
          this.safeSetInnerHTML(this.maxInputLength, fontInput.dataset.fontLimitation);
        }
      }

      // Motiv je Item wiederherstellen (oder Text-Modus)
      const itemId = el.value;
      let restoredAsync = false;

      if (this.motifs && this.motifs[itemId]) {
        this.motif = this.motifs[itemId];
      } else {
        const hiddenMotif = this.querySelector(".hidden-input-motif.hidden-item-" + itemId);
        const hiddenName = this.querySelector(".hidden-input-motif-name.hidden-item-" + itemId);
        if (hiddenMotif && hiddenMotif.value) {
          const src = hiddenMotif.value;
          const name = hiddenName?.value || "";
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            this.motif = { img, scale: 1, rotation: 0, src, name };
            if (!this.motifs) this.motifs = {};
            this.motifs[itemId] = this.motif;
            this.engravingDraw();
            this.updateSubmitState();
          };
          img.src = src;
          restoredAsync = true;
        } else {
          this.motif = null;
        }
      }

      if (!restoredAsync) {
        this.engravingDraw();
        this.updateSubmitState();
      }

      this.addEngravingId();
    }

    // Schreiben → Hidden-Text pro Item setzen + ggf. Motiv löschen
    writeInputEngraving() {
      if (
        this.motif &&
        this.engravingTextField &&
        this.engravingTextField.value.trim().length > 0
      ) {
        const checked = this.querySelector("input.engraving-item:checked");
        if (checked) {
          const hid = this.querySelector(".hidden-input-motif.hidden-item-" + checked.value);
          const hidName = this.querySelector(".hidden-input-motif-name.hidden-item-" + checked.value);
          if (hid) hid.value = "";
          if (hidName) hidName.value = "";
          if (this.motifs) delete this.motifs[checked.value];

          // 🆕 Hauptprodukt-Motivfelder für dieses Item ebenfalls leeren
          const mainSrc = this.querySelector(`.hidden-input-motif.hidden-main-${checked.value}`);
          const mainName = this.querySelector(`.hidden-input-motif-name.hidden-main-${checked.value}`);
          if (mainSrc) mainSrc.value = "";
          if (mainName) mainName.value = "";
        }
        this.motif = null;
      }

      if (!this.engravingTextField) return;

      this.safeSetInnerHTML(
        this.currentInputLength,
        this.engravingTextField.value.length.toString()
      );

      // Hidden-Text für das aktiv gewählte Item spiegeln
      const checkedItem = this.querySelector("input.engraving-item:checked");
      if (checkedItem) {
        for (const hiddenInput of this.querySelectorAll(
          ".hidden-input-text.hidden-item-" + checkedItem.value
        )) {
          if (hiddenInput) hiddenInput.value = this.engravingTextField.value;
        }
      }

      this.addEngravingId();
      this.engravingDraw();
      this.updateSubmitState();
    }


    // Submit-Button aktivieren, wenn (Text ODER Bild) für beide Items belegt ist
    updateSubmitState() {
      const btn = this.engravingSubmitButton;
      const info = this.querySelector("#InfoEngraving");

      const t1 = this.querySelector("#HiddenInputText1")?.value?.trim() || "";
      const t2 = this.querySelector("#HiddenInputText2")?.value?.trim() || "";

      const m1 = this.querySelector(".hidden-input-motif.hidden-item-1")?.value?.trim() || "";
      const m2 = this.querySelector(".hidden-input-motif.hidden-item-2")?.value?.trim() || "";

      const item1OK = !!(t1 || m1);
      const item2OK = !!(t2 || m2);
      const ready = item1OK && item2OK;

      if (btn) btn.toggleAttribute("disabled", !ready);
      if (info) info.style.display = ready ? "none" : "";
    }

    // Motiv laden: pro Item speichern + Hidden-Input setzen + State/Redraw
    loadMotif(src, name) {
      if (!src) return;

      const checked = this.querySelector("input.engraving-item:checked");
      if (!checked) return;
      const itemId = checked.value;

      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const motifObj = { img, scale: 1, rotation: 0, src, name };

        // Nur Text löschen (Font bleibt)
        const hiddenTexts = this.querySelectorAll(`.hidden-input-text.hidden-item-${itemId}`);
        hiddenTexts.forEach((t) => (t.value = ""));
        if (this.engravingTextField) this.engravingTextField.value = "";

        // Motiv-Inputs für das Item setzen
        const hiddenSrcs = this.querySelectorAll(`.hidden-input-motif.hidden-item-${itemId}`);
        const hiddenNames = this.querySelectorAll(`.hidden-input-motif-name.hidden-item-${itemId}`);
        hiddenSrcs.forEach((m) => (m.value = src));
        hiddenNames.forEach((n) => (n.value = name || ""));

        // 🆕 Hauptprodukt-Inputs (hidden-main-1 / hidden-main-2) befüllen
        const mainSrc = this.querySelector(`.hidden-input-motif.hidden-main-${itemId}`);
        const mainName = this.querySelector(`.hidden-input-motif-name.hidden-main-${itemId}`);
        if (mainSrc) mainSrc.value = src;
        if (mainName) mainName.value = name || "";

        // speichern & rendern
        this.motifs[itemId] = motifObj;
        this.motif = motifObj;
        this.engravingDraw();
        this.updateSubmitState();
      };
      img.src = src;
    }


    // In class SilwyEngravingMulti
    submitEngraving() {
      // Alle Hidden Inputs aktivieren
      const allHidden = this.querySelectorAll(
        ".engraving-hidden-inputs, .hidden-input-motif, .hidden-input-motif-name"
      );
      allHidden.forEach((h) => h.removeAttribute("disabled"));

      // Prüfe jedes Gravur-Item separat (1,2,…)
      const items = [1, 2];
      let textCount = 0;
      let motifCount = 0;

      items.forEach((i) => {
        const text = this.querySelector(`#HiddenInputText${i}`)?.value?.trim() || "";
        const motif = this.querySelector(`.hidden-input-motif.hidden-item-${i}`)?.value?.trim() || "";

        if (text) textCount++;
        if (motif) motifCount++;

        // Wenn Text → nur Text+Font aktiv, Motivfelder deaktivieren
        if (text && !motif) {
          this.querySelectorAll(
            `.hidden-input-motif.hidden-item-${i}, .hidden-input-motif-name.hidden-item-${i}`
          ).forEach((el) => el.setAttribute("disabled", ""));
        }

        // Wenn Motiv → nur Motiv aktiv, Text+Font deaktivieren
        if (motif && !text) {
          this.querySelectorAll(
            `.hidden-input-text.hidden-item-${i}, .hidden-input-font.hidden-item-${i}`
          ).forEach((el) => el.setAttribute("disabled", ""));
        }

        // Wenn leer → alles deaktivieren
        if (!text && !motif) {
          this.querySelectorAll(`.hidden-item-${i}`).forEach((el) =>
            el.setAttribute("disabled", "")
          );
        }
      });

      // HAUPTPRODUKT-Logik
      const hasText = textCount > 0;
      const hasMotif = motifCount > 0;

      if (hasText && !hasMotif) {
        this.querySelectorAll(".hidden-input-motif, .hidden-input-motif-name").forEach((el) =>
          el.setAttribute("disabled", "")
        );
      }

      if (hasMotif && !hasText) {
        this.querySelectorAll(".hidden-input-text, .hidden-input-font").forEach((el) =>
          el.setAttribute("disabled", "")
        );
      }

      if (!hasText && !hasMotif) {
        allHidden.forEach((el) => el.setAttribute("disabled", ""));
      }

      // 🛒 Add-to-cart Verhalten
      const anyHidden = this.hiddenEngravingInputs?.[0];
      const form = anyHidden?.form || document.querySelector('form[action*="/cart/add"]');
      if (this.engravingButton) this.engravingButton.classList.add("active");
      const box = document.getElementById("EngravingBox");
      if (box) box.style.display = "none";

      if (form) {
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      } else {
        console.warn("[SilwyEngraving] Kein Ziel-Formular gefunden.");
      }

      // ─────────────────────────────────────────────────────────────
      // 🧼 Nach dem Submit: Gravur-Box vollständig zurücksetzen
      // ─────────────────────────────────────────────────────────────
      setTimeout(() => {
        // Eingabefeld & Motive leeren
        if (this.engravingTextField) this.engravingTextField.value = "";
        this.motif = null;
        this.motifs = {};

        // Zeichenlänge zurücksetzen
        if (this.currentInputLength) this.safeSetInnerHTML(this.currentInputLength, "0");

        // Hidden Inputs leeren (Text / Motive / IDs)
        const clearSelectors = [
          ".hidden-input-text",
          ".hidden-input-motif",
          ".hidden-input-motif-name",
          ".hidden-input-id"
        ];
        clearSelectors.forEach((sel) => {
          this.querySelectorAll(sel).forEach((el) => {
            el.value = "";
            el.setAttribute("disabled", "");
          });
        });

        // Schriftart auf Standard zurücksetzen
        this.querySelectorAll(".hidden-input-font").forEach((el) => {
          el.value = "Caliban Std";
          el.setAttribute("disabled", "");
        });

        if (this.fontName) this.safeSetInnerHTML(this.fontName, "Caliban Std");

        // Canvas leeren
        if (this.engravingCtx && this.engravingCanvas) {
          this.engravingCtx.clearRect(
            0,
            0,
            this.engravingCanvas.width,
            this.engravingCanvas.height
          );
        }

        // Alle Gravur-Hidden-Inputs wieder deaktivieren
        this.querySelectorAll(".engraving-hidden-inputs").forEach((el) =>
          el.setAttribute("disabled", "")
        );

        // Buttons / UI zurücksetzen
        if (this.engravingSubmitButton) this.engravingSubmitButton.setAttribute("disabled", "");
        if (this.engravingButton) this.engravingButton.classList.remove("active");

        document.querySelector(".form-control--text-input")?.classList.add("hidden");
        document.querySelector(".font-wrapper")?.classList.add("hidden");
        document.querySelector(".image-input-wrapper")?.classList.add("hidden");
        document
          .querySelector(".engraving-toolbar")
          ?.classList.remove("hidden-important");
        document.querySelector(".button-back-to-start")?.classList.add("hidden-important");

        this.updateSubmitState();
        console.log("[SilwyEngravingMulti] GravurBox nach Submit vollständig zurückgesetzt.");
      }, 800);
    }



    cancelEngraving() {
      this.safeSetInnerHTML(this.currentInputLength, "0");

      for (const hiddenInput of this.hiddenEngravingInputs) {
        if (hiddenInput) {
          hiddenInput.setAttribute("disabled", "");
          if (hiddenInput.classList.contains("hidden-input-text")) hiddenInput.value = null;
        }
      }

      if (this.engravingTextField) this.engravingTextField.value = "";
      if (this.engravingSubmitButton) this.engravingSubmitButton.setAttribute("disabled", "");
      if (this.engravingButton) this.engravingButton.classList.remove("active");

      const engravingBox = document.getElementById("EngravingBox");
      if (engravingBox) engravingBox.style.display = "none";

      this.engravingDraw();

      const openButton = document.querySelector(".product-info__engraving .open-button");
      if (openButton && window.engraving && window.engraving.open_button) {
        openButton.innerHTML = window.engraving.open_button;
      }

      this.updateSubmitState();
    }
  }

  customElements.define("silwy-engraving-multi", SilwyEngravingMulti);

}
